module.exports = __webpack_public_path__ + "img/463818624_1067328201610093_8519598265867108245_n.d66d4f60.jpg";